import type { Callbacks, Context } from '../../model/index.tsx';

export const SET_APP_PROPS = 'state.actions.SET_APP_PROPS' as const;
export type SetAppPropsPayload = {
	callbacks: Callbacks;
	context: Context;
};
export type SetAppPropsAction = {
	type: typeof SET_APP_PROPS;
	payload: SetAppPropsPayload;
};
export const setAppProps = (payload: SetAppPropsPayload): SetAppPropsAction => ({
	type: SET_APP_PROPS,
	payload,
});

export type Action = SetAppPropsAction;
